import { render, staticRenderFns } from "./filmHeader.vue?vue&type=template&id=08addef6&scoped=true"
import script from "./filmHeader.vue?vue&type=script&lang=js"
export * from "./filmHeader.vue?vue&type=script&lang=js"
import style0 from "./filmHeader.vue?vue&type=style&index=0&id=08addef6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08addef6",
  null
  
)

export default component.exports